import { useState } from "react";

const RollingCommission = () => {
  const [dataSource, setDataSource] = useState("");
  const [sport, setSport] = useState("Cricket");
  const [startDate, setStartDate] = useState("15-07-2025");
  const [endDate, setEndDate] = useState("16-07-2025");

  const handleGetCommission = () => {
    console.log("Get Commission clicked", {
      dataSource,
      sport,
      startDate,
      endDate,
    });
  };

  const commissionData = [
    {
      type: "MATCH_ODDS",
      totalStack: "100",
      totalCommission: "0",
    },
  ];

  return (
    <div className="mx-auto bg-light-bg dark:bg-dark-bg border-t-2 rounded-t-md border-gray-900">
      <div className="bg-light-bg dark:bg-dark-bg p-4 space-y-4">
        <div className="grid grid-cols-2 gap-4">
          <div>
            <select
              value={dataSource}
              onChange={(e) => setDataSource(e.target.value)}
              className="w-full px-3 py-2 bg-light-bg dark:bg-dark-bg border border-gray-300 rounded focus:outline-none focus:border-blue-500 text-black dark:text-white"
            >
              <option value="">Data Source</option>
              <option value="source1">Source 1</option>
              <option value="source2">Source 2</option>
            </select>
          </div>
          <div>
            <select
              value={sport}
              onChange={(e) => setSport(e.target.value)}
              className="w-full px-3 py-2 bg-light-bg dark:bg-dark-bg border border-gray-300 rounded focus:outline-none focus:border-blue-500 text-black dark:text-white"
            >
              <option value="Cricket">Cricket</option>
              <option value="Football">Football</option>
              <option value="Tennis">Tennis</option>
            </select>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-4">
          <div className="relative">
            <input
              type="text"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              className="w-full px-3 py-2 bg-light-bg dark:bg-dark-bg border border-gray-300 rounded focus:outline-none focus:border-blue-500 text-black dark:text-white pr-10"
              placeholder="DD-MM-YYYY"
            />
            <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
              <svg
                className="w-5 h-5 text-gray-500"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                />
              </svg>
            </div>
          </div>
          <div className="relative">
            <input
              type="text"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              className="w-full px-3 py-2 bg-light-bg dark:bg-dark-bg border border-gray-300 rounded focus:outline-none focus:border-blue-500 text-black dark:text-white pr-10"
              placeholder="DD-MM-YYYY"
            />
            <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
              <svg
                className="w-5 h-5 text-gray-500"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                />
              </svg>
            </div>
          </div>
        </div>
        <div>
          <button
            onClick={handleGetCommission}
            className="w-full bg-[#6A7D88] hover:bg-slate-700 text-white font-medium py-2 px-4 rounded transition-colors"
          >
            Get Commission
          </button>
        </div>
      </div>

      <div className="mt-4">
        <div className="p-1.5 rounded-t bg-[linear-gradient(-180deg,_#2E4B5E_0%,_#243A48_82%)]">
          <h2 className="text-white text-sm font-semibold">
            Rolling Commission
          </h2>
        </div>
        <div className="bg-light-bg dark:bg-dark-bg">
          <div className="overflow-x-auto p-3">
            <table className="w-full border-collapse border border-gray-300-  ">
              <thead>
                <tr className="bg-[#E0E6E6] text-sm">
                  <th
                    className="px-4 py-3 text-left text-gray-950 font-semibold border-r border-gray-300"
                    scope="col"
                  >
                    Type
                  </th>
                  <th
                    className="px-4 py-3 text-left text-gray-950 font-semibold border-r border-gray-300"
                    scope="col"
                  >
                    Total Stack
                  </th>
                  <th
                    className="px-4 py-3 text-left text-gray-950 font-semibold"
                    scope="col"
                  >
                    Total Commission
                  </th>
                </tr>
              </thead>
              <tbody>
                {commissionData.map((row, index) => (
                  <tr
                    key={index}
                    className="border-b border-gray-300 last:border-b-0 text-sm"
                  >
                    <td className="px-4 py-3 text-gray-950 border-r border-gray-300">
                      {row.type}
                    </td>
                    <td className="px-4 py-3 text-gray-950 border-r border-gray-300">
                      {row.totalStack}
                    </td>
                    <td className="px-4 py-3 text-gray-950">
                      {row.totalCommission}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RollingCommission;
